import { Box, Flex } from '@lego/klik-ui';
import type { ReactElement } from 'react';
import { Loader, TextHeader } from '../common';

type Props = {
  count?: number;
  name: string;
  icon: ReactElement;
};

export const KpiCard = (props: Props) => {
  return props.count === undefined ? (
    <Loader />
  ) : (
    <Flex alignItems="center">
      {props.icon}
      <Box p={5}>
        <TextHeader tagLevel="h4" title={props.name} weight="normal" />
        <TextHeader mb={0} tagLevel="h1" title={props.count.toString()} />
      </Box>
    </Flex>
  );
};
